export default "__VITE_ASSET__8jm0LFjS__"